import { render, staticRenderFns } from "./LeafletMapCatalogsButton.vue?vue&type=template&id=4a929842&"
import script from "./LeafletMapCatalogsButton.vue?vue&type=script&lang=js&"
export * from "./LeafletMapCatalogsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports